import header from "./header_template";
import { categorylink } from "./header_template";
// import "./header.scss";


export default (categories) => {
    
    let headercontainer = document.getElementById("site_header");
    
    const timelineLinks = [];
    
    categories.forEach(maincategory => {
       
       if(maincategory.categoryId === "e94d7a64-2cc1-459c-8e9a-a912e8691615"){ // Hardwired category "tidslinje"
           maincategory.children.forEach(category => {
                timelineLinks.push(categorylink(category, maincategory)) 
           });
       }
        
    });
    
    headercontainer.innerHTML = header(timelineLinks.join(""));
    
    document.getElementById("togglemenu").addEventListener("click", () => {
        
        const iconArrow = document.getElementById("logoicon-arrow");
        const iconClose = document.getElementById("logoicon-close");
        const navContainer = document.querySelector(".globalnav__container");
        const menuText = document.getElementById("menu-text");
        const background = document.querySelector(".header__overlay");
        // console.log("click");
        
        if([...iconArrow.classList].includes("d-none")){
            iconArrow.classList.remove("d-none");
            iconClose.classList.add("d-none");
            navContainer.classList.add("d-none");
            background.classList.add("d-none");
            menuText.innerText = "Meny";
        }
        else {
            iconArrow.classList.add("d-none");
            iconClose.classList.remove("d-none");
            navContainer.classList.remove("d-none");
            background.classList.remove("d-none");
            menuText.innerText = "Lukk";
        }
        
    }, false)
    
    
}